import {Check, Cross, Loader2} from 'lucide-react'
import * as React from 'react'
import {useSpinDelay} from 'spin-delay'

import {Button, type ButtonProps} from '#app/ui/button'
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from '#app/ui/tooltip'
import {cn} from '#app/utils/misc'

export const StatusButton = React.forwardRef<
  HTMLButtonElement,
  ButtonProps & {
    status: 'pending' | 'success' | 'error' | 'idle'
    message?: string | null
    spinDelay?: Parameters<typeof useSpinDelay>[1]
  }
>(({message, status, className, children, spinDelay, ...props}, ref) => {
  const delayedPending = useSpinDelay(status === 'pending', {
    delay: 400,
    minDuration: 300,
    ...spinDelay,
  })
  const companion = {
    pending: delayedPending ? <Loader2 className="animate-spin" /> : null,
    success: <Check />,
    error: <Cross className="text-destructive-foreground" />,
    idle: null,
  }[status]

  return (
    <Button ref={ref} className={cn('flex justify-center gap-4', className)} {...props}>
      {children}
      {message ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>{companion}</TooltipTrigger>
            <TooltipContent>{message}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        companion
      )}
    </Button>
  )
})
StatusButton.displayName = 'Button'
